import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.scss'

// Suppress React DevTools and React Router console messages
const suppressConsoleMessages = (originalMethod) => {
  return (...args) => {
    const message = args.join(' ');
    // Suppress React DevTools messages
    if (message.includes('react-devtools') || message.includes('reactjs.org/link/react-devtools') || message.includes('Download the React DevTools')) {
      return;
    }
    // Suppress React Router future flag warnings
    if (message.includes('React Router Future Flag Warning') || message.includes('v7_startTransition') || message.includes('v7_relativeSplatPath')) {
      return;
    }
    originalMethod.apply(console, args);
  };
};

// Intercept console methods that React and React Router might use
console.log = suppressConsoleMessages(console.log);
console.info = suppressConsoleMessages(console.info);
console.warn = suppressConsoleMessages(console.warn);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)